import React, { useEffect, useRef, useState } from "react";
import { createNote } from "../../../../store/actions/detailsDocument/notes";
import { clearDetail, getDetailDocument } from "../../../../store/actions/detailsDocument";
import moment from "moment";
import { DATE_FORMAT_FOR_DISPLAY } from "../../../../constants/constants";
import Scrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";

const MessageNote = ({isNoteVisible, docId, setIsNoteVisible}) => {
  const dispatch = useDispatch();
  const [newNote, setNewNote] = useState("");
  const [isCreateError, setIsCreateError] = useState(false);
  const notes = useSelector(state => state.detailsDocument?.info?.details?.notes);
  const isNoteCreating = useSelector(state => state?.notes?.status?.statusNew?.loading);

  const notesLoading = useSelector(state => state.detailsDocument?.info?.status?.started);

  const notesRef = useRef();

  useEffect(() => {
    if (!notesRef?.current || !isNoteVisible) return undefined;
    let ps = new Scrollbar(notesRef.current, {wheelPropagation: true});
    return () => {
      if (ps) {
        ps.destroy();
        ps = null;
      }
    };
  }, [notesRef?.current, isNoteVisible]);

  useEffect(() => {  
    if (!isNoteVisible) return undefined;
    if (!docId) return undefined;
    dispatch(getDetailDocument(docId));
    return (() => {
      dispatch(clearDetail());
    });
  }, [docId, isNoteVisible]);
  
  return (<div style={{width: "300px"}}>
    <div style={{position: "absolute",right: "32px", zIndex: 99, cursor: "pointer"}} onClick={() => setIsNoteVisible(false)} >
      <FontAwesomeIcon
        style={{fontSize: "16px", cursor: "pointer", color: "#0090d1", fontWeight: "bold"}}
        icon={["far", "times"]}
      />
    </div>
    <div className="notesContainer" style={{ maxHeight: "200px", position: "relative"}} ref={notesRef} >
      {
        notesLoading &&
        <div style={{textAlign: "center"}}>
          <FontAwesomeIcon
            icon={["far", "circle-notch"]}
            spin
            style={{ color: "#0090d1" }}
          />
        </div>
      }
      {
        notes?.map(el => {
          return (
            <div key={el.id} style={{margin: "8px 0", color: "#152935"}}>
              <div style={{fontWeight: "bold", fontSize: "16px"}}>{el.userName}</div>
              <div style={{fontSize: "12px", color:"#9da6ad", marginTop: "5px"}}>{moment(el.createdOn).format(DATE_FORMAT_FOR_DISPLAY)}</div>
              <div>{el.noteText}</div>
            </div>
          );
        })
      }
    </div>
    <hr style={{ width: "100%", borderTop: "1px solid #c9d9e8", margin: "21px 0 30px 0px"}} />
    <div style={{marginTop: "16px"}}>
      <div>
        <Input
          className={`${isCreateError ? "inputError" : ""} inputCustom drawer-inputCustom`}
          value={newNote}
          placeholder={useIntl().formatMessage({ id: "preCog.message.placeholder" })}
          onChange={(e) => {
            setIsCreateError(false);
            setNewNote(e.target.value);
          }}
        />
        {isCreateError && <div style={{color: "#d82829", marginTop: "8px"}}>
          <FontAwesomeIcon
            icon={["fas", "minus-circle"]}
            style={{ color: "#d82829" }}
          /> <FormattedMessage id="preCog.message.error" /></div>}
      </div>
      {
        isNoteCreating ?
          <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            margin: "16px 0 16px 0",
            cursor: "pointer"
          }}>
            <FontAwesomeIcon
              icon={["far", "circle-notch"]}
              spin
              style={{ color: "#0090d1", fontSize: "16px" }}
            />
          </div>
          :
          <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            margin: "16px 0 16px 0",
            cursor: "pointer"
          }}
          onClick={() => {
            dispatch(createNote(docId, newNote)).then(res => {
              // reset newNote
              setNewNote(null);
              setTimeout(() => {
                notesRef.current.scrollTop = notesRef.current.scrollHeight;
              }, 300);

            }).catch(err => {
              setIsCreateError(true);
            });
          }}
          >
            <FontAwesomeIcon icon={["far", "paper-plane"]} className="pre-cog-detail-header-preview" />
            <span style={{color: "#0090d1", marginLeft: "8px", fontSize: "16px",
              fontWeight: 500}}><FormattedMessage id="preCog.message.send" /></span>
          </div>
      }
    </div>
  </div>);
};

export default MessageNote;
